
export class PaginableList<T>{
  pageSize: number
  pageIndex: number
  data: T[]
  page: T[]
  source: T[]

  constructor(source:T[]=undefined, pageSize:number=10, pageIndex:number=0){
    this.pageSize = pageSize
    this.data = this.source = source
    this.pageIndex = pageIndex
    this.paginate(pageIndex)
  }

  public update(data:T[]=this.data, pageIndex:number=this.pageIndex){
    this.data = data
    this.paginate(pageIndex)
  }

  public paginate(pageIndex:number=0){
    if(!!this.data){

      let pagesAvailable = Math.ceil(this.data.length / this.pageSize)-1
      if(pagesAvailable < 0) pagesAvailable = 0

      if(pageIndex > pagesAvailable){ pageIndex = pagesAvailable }

      let startIndex = pageIndex * this.pageSize;
      let endIndex = startIndex + this.pageSize;
      if (endIndex > this.source.length) {endIndex = this.data.length; }

      // Set state
      this.pageIndex = pageIndex
      this.page = this.data.slice(startIndex, endIndex);
    }
  }
}
